import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
  root: {
    height: 0,
    width: 0,
  },
}));

export default function ScrollIntoView({ afterScroll, ...rest }) {
  const element = React.useRef();
  const classes = useStyles();

  React.useEffect(() => {
    element.current.scrollIntoView({ behavior: 'smooth' });
    if (afterScroll) afterScroll();
  });

  return <div ref={element} className={classes.root} {...rest} />;
}

ScrollIntoView.defaultProps = {
  afterScroll: null,
};

ScrollIntoView.propTypes = {
  afterScroll: PropTypes.func,
};
